import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WithdrawalVerify2fa.css';

const WithdrawalVerify2fa: React.FC = () => {
  const navigate = useNavigate();
  const [otpCode, setOtpCode] = useState('');

  const isCodeComplete = otpCode.length === 6;

  const handleBack = () => {
    navigate(-1);
  };

  const handleVerify = () => {
    if (isCodeComplete) {
      navigate('/withdrawal-success');
    }
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow digits
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 6) {
      setOtpCode(value);
    }
  };

  return (
    <div className="verify-2fa-container">
      {/* Header */}
      <header className="verify-2fa-header">
        <button className="verify-2fa-back-btn" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="verify-2fa-title">Verify 2FA</h1>
      </header>

      {/* Content */}
      <div className="verify-2fa-content">
        <div className="verify-2fa-card">
          <h2 className="verify-2fa-heading">One Time Passcode</h2>
          <p className="verify-2fa-description">
            Please enter the 6 digit code sent to your<br />Email
          </p>

          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={otpCode}
            onChange={handleCodeChange}
            className="verify-2fa-input"
            placeholder=""
            autoComplete="one-time-code"
          />

          <button
            className="verify-2fa-btn"
            disabled={!isCodeComplete}
            onClick={handleVerify}
          >
            Verify Transfer
          </button>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalVerify2fa;
